/** Localized article titles, excerpts, bodies, and categories (seed article ids ar-1 … ar-16). */

export const CATEGORY_LABELS = {
  en: {
    "Scam Awareness": "Scam Awareness",
    "Recovery Guides": "Recovery Guides",
    "Telegram Scam Alerts": "Telegram Scam Alerts",
    "Legal Steps": "Legal Steps",
    "Investment Safety": "Investment Safety",
    "Cyber Safety": "Cyber Safety",
    "Real Stories": "Real Stories",
    "Banking & UPI": "Banking & UPI",
    "Insurance Disputes": "Insurance Disputes",
    "Airline & Travel": "Airline & Travel",
    "Consumer Disputes": "Consumer Disputes",
    "Housing Finance": "Housing Finance",
    "Pension & NPS": "Pension & NPS",
    "Cyber Fraud": "Cyber Fraud",
    "Other Financial Loss": "Other Financial Loss",
  },
  hi: {
    "Scam Awareness": "स्कैम जागरूकता",
    "Recovery Guides": "रिकवरी गाइड",
    "Telegram Scam Alerts": "टेलीग्राम स्कैम अलर्ट",
    "Legal Steps": "कानूनी कदम",
    "Investment Safety": "निवेश सुरक्षा",
    "Cyber Safety": "साइबर सुरक्षा",
    "Real Stories": "सच्ची कहानियाँ",
  },
  te: {
    "Scam Awareness": "స్కామ్ అవగాహన",
    "Recovery Guides": "రికవరీ గైడ్‌లు",
    "Telegram Scam Alerts": "టెలిగ్రామ్ స్కామ్ అలర్ట్‌లు",
    "Legal Steps": "చట్టపరమైన దశలు",
    "Investment Safety": "పెట్టుబడి భద్రత",
    "Cyber Safety": "సైబర్ భద్రత",
    "Real Stories": "నిజమైన కథలు",
  },
  ta: {
    "Scam Awareness": "மோசடி விழிப்புணர்வு",
    "Recovery Guides": "மீட்பு வழிகாட்டிகள்",
    "Telegram Scam Alerts": "டெலிகிராம் மோசடி எச்சரிக்கை",
    "Legal Steps": "சட்ட நடவடிக்கைகள்",
    "Investment Safety": "முதலீட்டு பாதுகாப்பு",
    "Cyber Safety": "சைபர் பாதுகாப்பு",
    "Real Stories": "உண்மை கதைகள்",
  },
  bn: {
    "Scam Awareness": "প্রতারণা সচেতনতা",
    "Recovery Guides": "পুনরুদ্ধার গাইড",
    "Telegram Scam Alerts": "টেলিগ্রাম স্ক্যাম সতর্কতা",
    "Legal Steps": "আইনি পদক্ষেপ",
    "Investment Safety": "বিনিয়োগ নিরাপত্তা",
    "Cyber Safety": "সাইবার নিরাপত্তা",
    "Real Stories": "বাস্তব গল্প",
  },
  mr: {
    "Scam Awareness": "फसवणूक जागरूकता",
    "Recovery Guides": "पुनर्प्राप्ती मार्गदर्शक",
    "Telegram Scam Alerts": "टेलिग्राम स्कॅम सूचना",
    "Legal Steps": "कायदेशीर पावले",
    "Investment Safety": "गुंतवणूक सुरक्षा",
    "Cyber Safety": "सायबर सुरक्षा",
    "Real Stories": "खऱ्या कथा",
  },
  kn: {
    "Scam Awareness": "ವಂಚನೆ ಅರಿವು",
    "Recovery Guides": "ಪುನರ್‌ಪ್ರಾಪ್ತಿ ಮಾರ್ಗದರ್ಶಿ",
    "Telegram Scam Alerts": "ಟೆಲಿಗ್ರಾಮ್ ವಂಚನೆ ಎಚ್ಚರಿಕೆ",
    "Legal Steps": "ಕಾನೂನು ಹಂತಗಳು",
    "Investment Safety": "ಹೂಡಿಕೆ ಸುರಕ್ಷತೆ",
    "Cyber Safety": "ಸೈಬರ್ ಸುರಕ್ಷತೆ",
    "Real Stories": "ನಿಜವಾದ ಕಥೆಗಳು",
  },
  ml: {
    "Scam Awareness": "തട്ടിപ്പ് അവബോധം",
    "Recovery Guides": "വീണ്ടെടുക്കൽ ഗൈഡുകൾ",
    "Telegram Scam Alerts": "ടെലിഗ്രാം സ്കാം അലേർട്ടുകൾ",
    "Legal Steps": "നിയമ ഘട്ടങ്ങൾ",
    "Investment Safety": "നിക്ഷേപ സുരക്ഷ",
    "Cyber Safety": "സൈബർ സുരക്ഷ",
    "Real Stories": "യഥാർത്ഥ കഥകൾ",
  },
  pa: {
    "Scam Awareness": "ਧੋਖਾਧੜੀ ਜਾਗਰੂਕਤਾ",
    "Recovery Guides": "ਰਿਕਵਰੀ ਗਾਈਡ",
    "Telegram Scam Alerts": "ਟੈਲੀਗ੍ਰਾਮ ਸਕੈਮ ਅਲਰਟ",
    "Legal Steps": "ਕਾਨੂੰਨੀ ਕਦਮ",
    "Investment Safety": "ਨਿਵੇਸ਼ ਸੁਰੱਖਿਆ",
    "Cyber Safety": "ਸਾਈਬਰ ਸੁਰੱਖਿਆ",
    "Real Stories": "ਅਸਲ ਕਹਾਣੀਆਂ",
  },
};

export const ARTICLE_I18N = {
  "ar-1": {
    hi: {
      title: "60 सेकंड में SEBI पंजीकृत निवेश सलाहकार की पुष्टि कैसे करें",
      excerpt: "आधिकारिक SEBI पोर्टल का उपयोग करके चरणदर चरण सत्यापन गाइड।",
      body: "sebi.gov.in/Investors पर जाएँ और 'Recognised Investment Advisors' खोज का उपयोग करें।",
    },
    te: {
      title: "60 సెకన్లలో SEBI నమోదిత ఇన్వెస్ట్‌మెంట్ అడ్వైజర్‌ను ఎలా ధృవీకరించాలి",
      excerpt: "అధికారిక SEBI పోర్టల్‌తో దశలవారీ ధృవీకరణ గైడ్.",
      body: "sebi.gov.in/Investors కు వెళ్లి 'Recognised Investment Advisors' శోధనను ఉపయోగించండి.",
    },
    ta: {
      title: "60 வினாடிகளில் SEBI பதிவு முதலீட்டு ஆலோசகரை எப்படி சரிபார்ப்பது",
      excerpt: "அதிகாரப்பூர்வ SEBI தளத்துடன் படிப்படியான சரிபார்ப்பு வழிகாட்டி.",
      body: "sebi.gov.in/Investors க்குச் சென்று 'Recognised Investment Advisors' தேடலைப் பயன்படுத்துங்கள்.",
    },
  },
  "ar-2": {
    hi: {
      title: "साइबर अपराध शिकायत दर्ज करें: पूरी प्रक्रिया",
      excerpt: "cybercrime.gov.in पर शिकायत निःशुल्क है और लगभग 20 मिनट लगते हैं।",
      body: "cybercrime.gov.in खोलें। 'Report Other Cyber Crime' चुनें और सबूत अपलोड करें।",
    },
    te: {
      title: "సైబర్ క్రైమ్ ఫిర్యాదు: పూర్తి వాక్‌త్రూ",
      excerpt: "cybercrime.gov.in వద్ద ఫిర్యాదు ఉచితం; సుమారు 20 నిమిషాలు పడుతుంది.",
      body: "cybercrime.gov.in తెరవండి. 'Report Other Cyber Crime' ఎంచుకుని సాక్ష్యాలు అప్‌లోడ్ చేయండి.",
    },
    ta: {
      title: "சைபர் குற்ற புகார்: முழு வழிமுறை",
      excerpt: "cybercrime.gov.in இல் புகார் இலவசம்; சுமார் 20 நிமிடங்கள் ஆகும்.",
      body: "cybercrime.gov.in திறந்து 'Report Other Cyber Crime' தேர்ந்து ஆதாரங்களை பதிவேற்றுங்கள்.",
    },
  },
  "ar-3": {
    hi: {
      title: "टेलीग्राम ट्रेडिंग ग्रुप में 5 लाल झंडे",
      excerpt: "इनमें से कोई भी दो संकेत दिखें तो तुरंत ग्रुप छोड़ दें।",
      body: "पिन किए गए प्रॉफिट स्क्रीनशॉट, गारंटीड सटीकता, अपग्रेड का दबाव, एडमिन DM, पंप पोस्ट।",
    },
    te: {
      title: "టెలిగ్రామ్ ట్రేడింగ్ గ్రూప్‌లో 5 రెడ్ ఫ్లాగ్‌లు",
      excerpt: "ఈ సంకేతాలలో రెండు కనిపిస్తే వెంటనే గ్రూప్ ను వదిలేయండి.",
      body: "పిన్ చేసిన లాభ స్క్రీన్‌షాట్‌లు, హామీ లాభాలు, అప్‌గ్రేడ్ ఒత్తిడి, అడ్మిన్ DM, పంప్ పోస్ట్‌లు.",
    },
    ta: {
      title: "டெலிகிராம் வர்த்தக குழுவில் 5 சிவப்பு கொடிகள்",
      excerpt: "இந்த அறிகுறிகளில் இரண்டு தெரிந்தால் உடனே குழுவை விட்டு வெளியேறுங்கள்.",
      body: "பின் செய்யப்பட்ட லாப ஸ்கிரீன்ஷாட், உத்தரவாத லாபம், அழுத்தம், நிர்வாகி DM, பம்ப் போஸ்ட்.",
    },
  },
  "ar-4": {
    hi: {
      title: "SEBI SCORES बनाम SMART ODR: कब क्या उपयोग करें",
      excerpt: "दोनों आधिकारिक शिकायत चैनल हैं।",
      body: "SCORES सूचीबद्ध कंपनियों के खिलाफ। SMART ODR पंजीकृत बिचौलिए विवादों के लिए।",
    },
    te: {
      title: "SEBI SCORES vs SMART ODR: ఏది ఎప్పుడు",
      excerpt: "రెండూ అధికారిక ఫిర్యాదు ఛానెల్‌లు.",
      body: "SCORES లిస్ట్ చేసిన సంస్థలపై. SMART ODR నమోదిత ఇంటర్మీడియరీ వివాదాలకు.",
    },
    ta: {
      title: "SEBI SCORES vs SMART ODR: எப்போது எது",
      excerpt: "இரண்டும் அதிகாரப்பூர்வ புகார் வழிகள்.",
      body: "SCORES பட்டியலிடப்பட்ட நிறுவனங்களுக்கு. SMART ODR பதிவு இடைத்தரகர் வழக்குகளுக்கு.",
    },
  },
  "ar-5": {
    hi: {
      title: "अकाउंट-हैंडलिंग वादे हमेशा घोटाला क्यों हैं",
      excerpt: "भारतीय कानून किसी तीसरे पक्ष को आपका डीमैट चलाने की अनुमति नहीं देता।",
      body: "केवल SEBI-पंजीकृत पोर्टफोलियो मैनेजर ही फंड प्रबंधित कर सकते हैं।",
    },
    te: {
      title: "అకౌంట్ హ్యాండ్లింగ్ హామీలు ఎందుకు మోసాలు",
      excerpt: "భారత చట్టం మీ డీమ్యాట్‌ను మరొకరు నడపడానికి అనుమతించదు.",
      body: "SEBI నమోదిత పోర్ట్‌ఫోలియో మేనేజర్‌లు మాత్రమే నిర్వహించగలరు.",
    },
    ta: {
      title: "கணக்கு நிர்வாக வாக்குறுதிகள் ஏன் மோசடி",
      excerpt: "இந்திய சட்டம் மூன்றாம் தரப்பினர் உங்கள் டீமேட்டை நடத்த அனுமதிக்காது.",
      body: "SEBI பதிவு போர்ட்ஃபோலியோ மேலாளர்கள் மட்டுமே நிர்வகிக்க முடியும்.",
    },
  },
  "ar-6": {
    hi: {
      title: "आपको घोटाला समझ आने के पहले 30 मिनट",
      excerpt: "पहले 30 मिनट में क्या करें — चरणदर।",
      body: "बैंक फ्रॉड हेल्पलाइन, चैट स्क्रीनशॉट, UPI रेफरेंस, cybercrime.gov.in, ब्रोकर को सूचित करें।",
    },
    te: {
      title: "మోసం అర్థమైన మొదటి 30 నిమిషాలు",
      excerpt: "మొదటి 30 నిమిషాల్లో చేయవలసిన చర్యలు.",
      body: "బ్యాంక్ ఫ్రాడ్ హాట్‌లైన్, చాట్ స్క్రీన్‌షాట్‌లు, UPI రెఫరెన్స్, cybercrime.gov.in, బ్రోకర్‌కు తెలియజేయండి.",
    },
    ta: {
      title: "மோசடி தெரிந்த முதல் 30 நிமிடங்கள்",
      excerpt: "முதல் 30 நிமிடங்களில் செய்ய வேண்டியவை.",
      body: "வங்கி மோசடி ஹாட்லைன், அரட்டை ஸ்கிரீன்ஷாட், UPI குறிப்பு, cybercrime.gov.in, தரகருக்கு தெரிவிக்கவும்.",
    },
  },
};

// ar-7 … ar-16: localized titles/excerpts; body falls back to English from API when omitted
const ARTICLE_META = {
  "ar-7": {
    hi: { title: "SEBI SCORES पर शिकायत कैसे दर्ज करें — चरणबद्ध", excerpt: "12-चरण गाइड, दस्तावेज़ सूची और नमूना शिकायत पाठ।" },
    te: { title: "SEBI SCORES ఫిర్యాదు — దశలవారీ", excerpt: "12 దశల గైడ్, పత్రాల చెక్‌లిస్ట్ మరియు నమూనా ఫిర్యాదు." },
    ta: { title: "SEBI SCORES புகார் — படிப்படியாக", excerpt: "12 படிகள், ஆவண சரிபார்ப்பு பட்டியல் மற்றும் மாதிரி புகார்." },
  },
  "ar-8": {
    hi: { title: "ट्रेडिंग घोटाले के बाद आर्थिक नुकसान की वसूली — 7 चरण", excerpt: "पहले घंटे से छठे महीने तक भारत में क्या काम करता है।" },
    te: { title: "ట్రేడింగ్ మోసం తర్వాత నష్టం రికవరీ — 7 దశలు", excerpt: "మొదటి గంట నుండి ఆరు నెలల వరకు భారతదేశంలో ఏమి పని చేస్తుంది." },
    ta: { title: "வர்த்தக மோசடிக்குப் பிறகு இழப்பு மீட்பு — 7 நிலைகள்", excerpt: "முதல் மணி நேரம் முதல் ஆறு மாதம் வரை இந்தியாவில் எது செயல்படும்." },
  },
  "ar-9": {
    hi: { title: "SEBI-पंजीकृत निवेश सलाहकार (RIA) कैसे चुनें", excerpt: "वास्तविक RIA लिखित में उत्तर देगा — दो पर संकोच करे तो दूर रहें।" },
    te: { title: "SEBI RIA ఎలా ఎంచుకోవాలి — చెక్‌లిస్ట్", excerpt: "నిజమైన RIA రాతీరూపంలో సమాధానం ఇస్తాడు." },
    ta: { title: "SEBI RIA எப்படி தேர்வு — சரிபார்ப்பு பட்டியல்", excerpt: "உண்மையான RIA எழுத்தில் பதிலளிப்பார்." },
  },
  "ar-10": {
    hi: { title: "क्वोरा कबूलनामा: 'मैंने ट्रेडिंग मेंटर को ₹12 लाख खो दिए'", excerpt: "Quora और Reddit India से वास्तविक पीड़ित खातों के पाँच सामान्य स्क्रिप्ट।" },
    te: { title: "క్వోరా కథ: 'ట్రేడింగ్ మెంటర్‌కు ₹12 లక్షలు కోల్పోయాను'", excerpt: "ధృవీకరించబడిన బాధితుల నుండి ఐదు సాధారణ స్క్రిప్ట్‌లు." },
    ta: { title: "குவோரா கதை: 'மென்டருக்கு ₹12 லட்சம் இழந்தேன்'", excerpt: "சரிபார்க்கப்பட்ட பாதிக்கப்பட்டவர்களின் ஐந்து பொதுவான ஸ்கிரிப்ட்கள்." },
  },
  "ar-11": {
    hi: { title: "भारत में अकाउंट-हैंडलिंग वादे 100% अवैध क्यों हैं", excerpt: "केवल SEBI पोर्टफोलियो मैनेजर ही आपका खाता चला सकते हैं।" },
    te: { title: "అకౌంట్ హ్యాండ్లింగ్ హామీలు భారతదేశంలో ఎందుకు అక్రమం", excerpt: "SEBI పోర్ట్‌ఫోలియో మేనేజర్‌లు మాత్రమే నిర్వహించగలరు." },
    ta: { title: "கணக்கு நிர்வாக வாக்குறுதிகள் இந்தியாவில் ஏன் சட்டவிரோதம்", excerpt: "SEBI போர்ட்ஃபோலியோ மேனேஜர்கள் மட்டுமே நடத்த முடியும்." },
  },
  "ar-12": {
    hi: { title: "रिकवरी एजेंसियाँ: पहले घोटाले के बाद दूसरा घोटाला", excerpt: "वास्तविक रिकवरी कभी अग्रिम शुल्क नहीं मांगती।" },
    te: { title: "రికవరీ ఏజెన్సీలు: రెండవ మోసం", excerpt: "నిజమైన రికవరీ ముందస్తు ఫీజు అడగదు." },
    ta: { title: "மீட்பு நிறுவனங்கள்: இரண்டாவது மோசடி", excerpt: "உண்மையான மீட்பு முன்பணம் கேட்காது." },
  },
  "ar-13": {
    hi: { title: "SEBI का 2024–2026 फिनफ्लुएंसर क्रैकडाउन — क्या बदला", excerpt: "फिनफ्लुएंसर परिपत्र से अगस्त 2024 प्रतिबंध तक नियामक समयरेखा।" },
    te: { title: "SEBI 2024–2026 ఫిన్‌ఫ్లుయెన్సర్ క్రాక్‌డౌన్", excerpt: "పరిపత్ర నుండి 2024 నిషేధాల వరకు కాలరేఖ." },
    ta: { title: "SEBI 2024–2026 ஃபின்ஃப்ளூயன்சர் நடவடிக்கை", excerpt: "சுற்றுவட்டை முதல் 2024 தடை வரை காலவரிசை." },
  },
  "ar-14": {
    hi: { title: "FIR बनाम SEBI SCORES बनाम RBI Sachet — कौन सा फोरम कब", excerpt: "त्वरित निर्णय वृक्ष ताकि गलत नियामक पर 30 दिन न जाएँ।" },
    te: { title: "FIR vs SCORES vs RBI Sachet — ఏ ఫోరమ్ ఎప్పుడు", excerpt: "తప్పు నియంత్రకుడికి 30 రోజులు వృథా కాకుండా నిర్ణయ చెట్టు." },
    ta: { title: "FIR vs SCORES vs RBI Sachet — எந்த மன்றம் எப்போது", excerpt: "தவறான ஒழுங்குநரிடம் 30 நாட்கள் வீணாகாமல் முடிவு மரம்." },
  },
  "ar-15": {
    hi: { title: "किसी भी 'SEBI Reg. No.' को 60 सेकंड में सत्यापित करें", excerpt: "तीन URL बुकमार्क करें — एक मिनट में पुष्टि या खंडन।" },
    te: { title: "'SEBI Reg. No.' 60 సెకన్లలో ధృవీకరించండి", excerpt: "మూడు URL బుక్‌మార్క్ చేయండి — ఒక నిమిషంలో నిరూపణ." },
    ta: { title: "'SEBI Reg. No.' 60 வினாடிகளில் சரிபார்க்க", excerpt: "மூன்று URL புக்மார்க் — ஒரு நிமிடத்தில் உறுதிப்படுத்தல்." },
  },
  "ar-16": {
    hi: { title: "Reddit India: 47 पीड़ितों ने मिलकर SEBI को कैसे हिलाया", excerpt: "अकेले दायर करने की बजाय समन्वित SCORES शिकायत ने चेतावनी ट्रिगर की।" },
    te: { title: "Reddit India: 47 బాధితులు SEBIని ఎలా కదిలించారు", excerpt: "సమన్వయ SCORES ఫిర్యాదు హెచ్చరికను ప్రేరేపించింది." },
    ta: { title: "Reddit India: 47 பாதிக்கப்பட்டவர்கள் SEBI யை எப்படி அசைத்தார்கள்", excerpt: "ஒருங்கிணைந்த SCORES புகார் எச்சரிக்கையைத் தூண்டியது." },
  },
};

for (const [id, langs] of Object.entries(ARTICLE_META)) {
  ARTICLE_I18N[id] = { ...ARTICLE_I18N[id], ...langs };
}

export function localizeCategory(category, lang) {
  if (!category || !lang || lang === "en") return category;
  return CATEGORY_LABELS[lang]?.[category] || category;
}

export function localizeArticle(article, lang) {
  if (!article) return article;
  const categoryKey = article.categoryKey || article.category;
  const base = {
    ...article,
    categoryKey,
    category: localizeCategory(categoryKey, lang),
  };
  if (!lang || lang === "en") return base;

  const loc = ARTICLE_I18N[article.id]?.[lang];
  if (!loc) return base;

  return {
    ...base,
    title: loc.title ?? article.title,
    excerpt: loc.excerpt ?? article.excerpt,
    body: loc.body ?? article.body,
  };
}

export function localizeArticles(items, lang) {
  return (items || []).map((a) => localizeArticle(a, lang));
}
